export default "__VITE_ASSET__C60GOsQ4__"